import { render, staticRenderFns } from "./FixSmsPolicies.vue?vue&type=template&id=25ee39f3&scoped=true"
import script from "./FixSmsPolicies.vue?vue&type=script&lang=js"
export * from "./FixSmsPolicies.vue?vue&type=script&lang=js"
import style0 from "./FixSmsPolicies.vue?vue&type=style&index=0&id=25ee39f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee39f3",
  null
  
)

export default component.exports